import DateTime from 'typescript-dotnet-es6/System/Time/DateTime'
import { qaPropertiesHeader, gdsInfo, qaProperty, qaPropertySeasons } from '../../../../core/models/qa-properties-model';
import { SliderCustomMessagesComponent } from '@progress/kendo-angular-inputs';

function stringTruncate(str:string, len:number):string{
  if (!str) {
    return "";
  }
  return  str.substring(0, Math.min(len,str.length));
};

function reformatDate(str:string):string{
  if (!str || str=="") {
    return "";
  }
  if(str.length!=10){
    throw "bad date format, length should 10 characters";
  }
  return str[5]+str[6]+"/"+str[8]+str[9]+"/"+str.substr(0,4);
};


export class AuditStdImport {
  constructor() {
    this.property = [];
  }
  set(h: qaPropertiesHeader) {
    this.AccountName = h.accountName;
    this.ContractYear = h.contractPeriod.toFixed();
    this.CustomerAccountID =  stringTruncate(h.accountName,25);
    ;
    this.AuditAmadeus = true;
    this.AuditApollo = true;
    this.AuditGalileo = true;
    this.AuditSabre = true;
    this.AuditWorldspan = true;
    this.LanyonAccountID = h.lanyonAccountId.toString();
    this.ImportResults = {TotalPropertyCount: h.importResults.totalPropertyCount, CustomerID:h.importResults.customerID} ;

    let rerun = h.rerun;
    if (rerun) {
      this.RACFilters = rerun.rerunKeywords;
      this.SabrePCC = rerun.sabrePCC;
      this.AccountType = rerun.racType;
      this.AccountName = rerun.accountName;
      this.CustomerAccountID = rerun.accountID;
      this.ContractYear = rerun.contractPeriod.toFixed();
      this.AuditAmadeus = rerun.auditAmadeus;
      this.AuditApollo = rerun.auditApollo;
      this.AuditGalileo = rerun.auditGalileo;
      this.AuditSabre = rerun.auditSabre;
      this.AuditWorldspan = rerun.auditWorldspan;
      this.NextQuickAuditId = rerun.nextQuickAuditId;

    }

    if(h.properties){
      this.property = h.properties
      .map(p => new Property().set(p));
    }
    if (rerun) {
      this.property.forEach(p =>{
        p.AmadeusRateAccessCode = rerun.AmadeusRAC;
        p.ApolloRateAccessCode = rerun.ApolloRAC;
        p.GalileoRateAccessCode = rerun.GalileoRAC;
        p.SabreRateAccessCode = rerun.SabreRAC;
        p.WorldspanRateAccessCode = rerun.WorldspanRAC;
      })
    }
  }

  AuditAmadeus: boolean;
  AuditApollo: boolean;
  AuditGalileo: boolean;
  AuditSabre: boolean;
  AuditWorldspan: boolean;
  CustomerAccountID: string;
  LanyonAccountID: string;
  ContractYear: string;
  SabrePCC: string;
  RACFilters: string;
  AccountName: string;
  AccountType: string;
  ImportResults: ImportResults;
  property: Property[];
  NextQuickAuditId: string = "";


}
export interface ImportStatus {
  Errors: Errors;
  Warnings?: any;
}

export interface Errors {
  Error: Error[];
}

export interface Error {
  Message: string;
}

export interface ImportResults {
  TotalPropertyCount: string;
  CustomerID: string;
  PreviousAuditTitle?: string;
  PreviousAuditID?: string;
  MatchPropertyCount?: string;
}

export class Property {
  set(p: qaProperty): Property {
    this.LoadedFromOriginal =false;
    this.OriginalAuditPropertyID = p.originalAuditPropertyID
    this.HotelChainCode = p.hotelChainCode;
    this.ParentHotelName = p.parentHotelName;
    this.HotelCRSPropertyCode = p.hotelCRSCode;
    this.PropertyName = p.hotelName;
    this.PropertyAddress = p.address;
    this.PropertyCity = p.city;
    this.PropertyStateProvince = p.stateProvince;
    this.PropertyPostalCode = p.zipCode;
    this.PropertyCountry = stringTruncate(p.country,20);
    this.PropertyPhone = "+" + p.phoneCountry + " (" + p.phoneArea + ") " + p.phoneNumber + " " + p.phoneExt;
    this.ContactName = p.contactName;
    this.ContactEMail = p.contactEmail;
    this.RoomType = p.roomType;
    this.LRA = p.isLRA;
    this.RateCurrency = p.rateCurrency;
    this.LoadedFromOriginal = p.loadedFromOriginal == true;
    this.OriginalAuditPropertyID = p.originalAuditPropertyID;
    this.InitSeasons();
    p.seasons.forEach(s => {
      if(s.dates){
        s.dates = s.dates.map(s => reformatDate(s)) ;
      }
      this.Set(s.index, s.singleOccupancy, s.singleOccupancy.includes("%"), true, reformatDate(s.start), reformatDate(s.end), s.dates, s.cellingRate)
    })

    p.gdsInfo.forEach(g => {
      this.SetGDS(g.gds, g.chainCode, g.propCode, g.rac);
    })
    this.BidAmenityBreakfast = p.amenities.breakfast
    this.BidAmenityInternet = p.amenities.internet
    this.BidAmenityParking = p.amenities.parking
    this.BidAmenityAirport = p.amenities.transportationToAirport
    this.BidAmenityLocalShuttle = p.amenities.localOfficeTransportation
    this.BidPolicyCancellation = p.policies.cancellationPolicy;
    return this;
  }
  SetGDS(gds: string, chainCode: string, propCode: string, rac: string) {
    switch (gds) {
      case "Amadeus":
        this.AmadeusChainCode = chainCode;
        this.AmadeusPropCode = propCode;
        this.AmadeusRateAccessCode = rac;
        break;
      case "Apollo":
        this.ApolloChainCode = chainCode;
        this.ApolloPropCode = propCode;
        this.ApolloRateAccessCode = rac;
        break;
      case "Galileo":
        this.GalileoChainCode = chainCode;
        this.GalileoPropCode = propCode;
        this.GalileoRateAccessCode = rac;
        break;
      case "Sabre":
        this.SabreChainCode = chainCode;
        this.SabrePropCode = propCode;
        this.SabreRateAccessCode = rac;
        break;
      case "Worldspan":
        this.WorldspanChainCode = chainCode;
        this.WorldspanPropCode = propCode;
        this.WorldspanRateAccessCode = rac;
        break;

      default:
        break;
    }
  }
  HotelChainCode: string;
  ParentHotelName: string;
  HotelCRSPropertyCode: string;
  PropertyName: string;
  PropertyAddress: string;
  PropertyCity: string;
  PropertyStateProvince: string;
  PropertyPostalCode: string;
  PropertyCountry: string;
  PropertyPhone: string;
  ContactName: string;
  ContactEMail: string;
  ProcessAmadeus: boolean;
  ProcessApollo: boolean;
  ProcessGalileo: boolean;
  ProcessSabre: boolean;
  ProcessWorldspan: boolean;
  AmadeusChainCode: string="";
  AmadeusPropCode: string ="";
  AmadeusRateAccessCode: string="";
  ApolloChainCode: string="";
  ApolloPropCode: string="";
  ApolloRateAccessCode: string="";
  GalileoChainCode: string="";
  GalileoPropCode: string="";
  GalileoRateAccessCode: string="";
  SabreChainCode: string="";
  SabrePropCode: string="";
  SabreRateAccessCode: string="";
  WorldspanChainCode: string="";
  WorldspanPropCode: string="";
  WorldspanRateAccessCode: string="";
  RateCurrency: string;
  AutoExtractSeasons: boolean;
  RoomType: string;
  LRA: boolean;
  Season1OriginalStartDate: string;
  Season1OriginalEndDate: string;
  Season1TextStartDate: string;
  Season1TextEndDate: string;
  Season1StartDate: string;
  Season1EndDate: string;
  Season1Valid: boolean;
  Season1DateToCheck1: string;
  Season1DateToCheck2: string;
  Season1DateToCheck3: string;
  Season1DateToCheck4: string;
  Season1DateToCheck5: string;
  Season1ExpectedPrice: string;
  Season1Dynamic: boolean;
  Season2OriginalStartDate: string;
  Season2OriginalEndDate: string;
  Season2TextStartDate: string;
  Season2TextEndDate: string;
  Season2StartDate: string;
  Season2EndDate: string;
  Season2Valid: boolean;
  Season2DateToCheck1: string;
  Season2DateToCheck2: string;
  Season2DateToCheck3: string;
  Season2DateToCheck4: string;
  Season2DateToCheck5: string;
  Season2ExpectedPrice: string;
  Season2Dynamic: boolean;
  Season3OriginalStartDate: string;
  Season3OriginalEndDate: string;
  Season3TextStartDate: string;
  Season3TextEndDate: string;
  Season3StartDate: string;
  Season3EndDate: string;
  Season3Valid: boolean;
  Season3DateToCheck1: string;
  Season3DateToCheck2: string;
  Season3DateToCheck3: string;
  Season3DateToCheck4: string;
  Season3DateToCheck5: string;
  Season3ExpectedPrice: string;
  Season3Dynamic: boolean;
  Season4OriginalStartDate: string;
  Season4OriginalEndDate: string;
  Season4TextStartDate: string;
  Season4TextEndDate: string;
  Season4StartDate: string;
  Season4EndDate: string;
  Season4Valid: boolean;
  Season4DateToCheck1: string;
  Season4DateToCheck2: string;
  Season4DateToCheck3: string;
  Season4DateToCheck4: string;
  Season4DateToCheck5: string;
  Season4ExpectedPrice: string;
  Season4Dynamic: boolean;
  Season5OriginalStartDate: string;
  Season5OriginalEndDate: string;
  Season5TextStartDate: string;
  Season5TextEndDate: string;
  Season5StartDate: string;
  Season5EndDate: string;
  Season5Valid: boolean;
  Season5DateToCheck1: string;
  Season5DateToCheck2: string;
  Season5DateToCheck3: string;
  Season5DateToCheck4: string;
  Season5DateToCheck5: string;
  Season5ExpectedPrice: string;
  Season5Dynamic: boolean;
  Season6OriginalStartDate: string;
  Season6OriginalEndDate: string;
  Season6TextStartDate: string;
  Season6TextEndDate: string;
  Season6StartDate: string;
  Season6EndDate: string;
  Season6Valid: boolean;
  Season6DateToCheck1: string;
  Season6DateToCheck2: string;
  Season6DateToCheck3: string;
  Season6DateToCheck4: string;
  Season6DateToCheck5: string;
  Season6ExpectedPrice: string;
  Season6Dynamic: boolean;
  Season7OriginalStartDate: string;
  Season7OriginalEndDate: string;
  Season7TextStartDate: string;
  Season7TextEndDate: string;
  Season7StartDate: string;
  Season7EndDate: string;
  Season7Valid: boolean;
  Season7DateToCheck1: string;
  Season7DateToCheck2: string;
  Season7DateToCheck3: string;
  Season7DateToCheck4: string;
  Season7DateToCheck5: string;
  Season7ExpectedPrice: string;
  Season7Dynamic: boolean;
  Season8OriginalStartDate: string;
  Season8OriginalEndDate: string;
  Season8TextStartDate: string;
  Season8TextEndDate: string;
  Season8StartDate: string;
  Season8EndDate: string;
  Season8Valid: boolean;
  Season8DateToCheck1: string;
  Season8DateToCheck2: string;
  Season8DateToCheck3: string;
  Season8DateToCheck4: string;
  Season8DateToCheck5: string;
  Season8ExpectedPrice: string;
  Season8Dynamic: boolean;
  TempAuditPropertyID: string;
  LoadedFromOriginal: boolean;
  OriginalAuditPropertyID: string;
  ImportStatus: ImportStatus;
  EditEmail: boolean;
  BidAmenityBreakfast: string;
  BidAmenityInternet: string;
  BidAmenityParking: string;
  BidAmenityAirport: string;
  BidAmenityLocalShuttle: string;
  BidPolicyCancellation: string;

  Season1Ceiling: string;
  Season2Ceiling: string;
  Season3Ceiling: string;
  Season4Ceiling: string;
  Season5Ceiling: string;
  Season6Ceiling: string;
  Season7Ceiling: string;
  Season8Ceiling: string;

  public Set(season: number, expectedPrice: string, dynamicPrice: boolean, set: boolean, start: string, end: string, dates:string[], ceiling: string): void {
    var defaultPrice = this.Season1ExpectedPrice;
    var defaultDynmic = this.Season1Dynamic;
    var value = "-1";
    var v = Number.parseFloat(expectedPrice);
    if (dynamicPrice) {
      if (v != NaN) {
        value = (v/100).toString();
      }
    } else {
      if (v != NaN) {
        value = v.toString();
      }
    }
    if(season>1 && v == NaN){
      value = defaultPrice;
      defaultDynmic = defaultDynmic;
    }
    expectedPrice = value;

    if(expectedPrice=="-1")
      this.ImportStatus.Errors.Error.push({Message: "Season"+season+"ExpectedPrice is not a number"})
    switch (season) {

      case 1:
        this.Season1Dynamic = dynamicPrice;
        this.Season1ExpectedPrice = expectedPrice;
        this.Season1Valid = set;
        this.Season1StartDate = start;
        this.Season1EndDate = end;
        this.Season1OriginalStartDate = start;
        this.Season1OriginalEndDate = end;
        this.Season1Ceiling = ceiling;
        break;
      case 2:
        this.Season2Dynamic = dynamicPrice;
        this.Season2ExpectedPrice = expectedPrice;
        this.Season2Valid = set;
        this.Season2StartDate = start;
        this.Season2EndDate = end;
        this.Season2OriginalStartDate = start;
        this.Season2OriginalEndDate = end;
        this.Season2Ceiling = ceiling;
        break;
      case 3:
        this.Season3Dynamic = dynamicPrice;
        this.Season3ExpectedPrice = expectedPrice;
        this.Season3Valid = set;
        this.Season3StartDate = start;
        this.Season3EndDate = end;
        this.Season3OriginalStartDate = start;
        this.Season3OriginalEndDate = end;
        this.Season3Ceiling = ceiling;
        break;
      case 4:
        this.Season4Dynamic = dynamicPrice;
        this.Season4ExpectedPrice = expectedPrice;
        this.Season4Valid = set;
        this.Season4StartDate = start;
        this.Season4EndDate = end;
        this.Season4OriginalStartDate = start;
        this.Season4OriginalEndDate = end;
        this.Season4Ceiling = ceiling;
        break;
      case 5:
        this.Season5Dynamic = dynamicPrice;
        this.Season5ExpectedPrice = expectedPrice;
        this.Season5Valid = set;
        this.Season5StartDate = start;
        this.Season5EndDate = end;
        this.Season5OriginalStartDate = start;
        this.Season5OriginalEndDate = end;
        this.Season5Ceiling = ceiling;
        break;
      case 6:
        this.Season6Dynamic = dynamicPrice;
        this.Season6ExpectedPrice = expectedPrice;
        this.Season6Valid = set;
        this.Season6StartDate = start;
        this.Season6EndDate = end;
        this.Season6OriginalStartDate = start;
        this.Season6OriginalEndDate = end;
        this.Season6Ceiling = ceiling;
        break;
      case 7:
        this.Season7Dynamic = dynamicPrice;
        this.Season7ExpectedPrice = expectedPrice;
        this.Season7Valid = set;
        this.Season7StartDate = start;
        this.Season7EndDate = end;
        this.Season7OriginalStartDate = start;
        this.Season7OriginalEndDate = end;
        this.Season7Ceiling = ceiling;
        break;
      case 8:
        this.Season8Dynamic = dynamicPrice;
        this.Season8ExpectedPrice = expectedPrice;
        this.Season8Valid = set;
        this.Season8StartDate = start;
        this.Season8EndDate = end;
        this.Season8OriginalStartDate = start;
        this.Season8OriginalEndDate = end;
        this.Season8Ceiling = ceiling;
        break;
    }

    if(dates && dates.length>0){
      this.SetSeasonCheckDays(season, dates[0], dates[1], dates[2], dates[3], dates[4] )
    }

  }

  SetSeasonCheckDays(season: number,  date1:string, date2:string, date3:string, date4:string, date5:string) {

    switch (season) {
      case 1:
        this.Season1DateToCheck1 = date1;
        this.Season1DateToCheck2 = date2;
        this.Season1DateToCheck3 = date3;
        this.Season1DateToCheck4 = date4;
        this.Season1DateToCheck5 = date5;
        break;
      case 2:
        this.Season2DateToCheck1 = date1;
        this.Season2DateToCheck2 = date2;
        this.Season2DateToCheck3 = date3;
        this.Season2DateToCheck4 = date4;
        this.Season2DateToCheck5 = date5;
        break;
      case 3:
        this.Season3DateToCheck1 = date1;
        this.Season3DateToCheck2 = date2;
        this.Season3DateToCheck3 = date3;
        this.Season3DateToCheck4 = date4;
        this.Season3DateToCheck5 = date5;
        break;
      case 4:
        this.Season4DateToCheck1 = date1;
        this.Season4DateToCheck2 = date2;
        this.Season4DateToCheck3 = date3;
        this.Season4DateToCheck4 = date4;
        this.Season4DateToCheck5 = date5;
        break;
      case 5:
        this.Season5DateToCheck1 = date1;
        this.Season5DateToCheck2 = date2;
        this.Season5DateToCheck3 = date3;
        this.Season5DateToCheck4 = date4;
        this.Season5DateToCheck5 = date5;
        break;
      case 6:
        this.Season6DateToCheck1 = date1;
        this.Season6DateToCheck2 = date2;
        this.Season6DateToCheck3 = date3;
        this.Season6DateToCheck4 = date4;
        this.Season6DateToCheck5 = date5;
        break;
      case 7:
        this.Season7DateToCheck1 = date1;
        this.Season7DateToCheck2 = date2;
        this.Season7DateToCheck3 = date3;
        this.Season7DateToCheck4 = date4;
        this.Season7DateToCheck5 = date5;
        break;
      case 8:
        this.Season8DateToCheck1 = date1;
        this.Season8DateToCheck2 = date2;
        this.Season8DateToCheck3 = date3;
        this.Season8DateToCheck4 = date4;
        this.Season8DateToCheck5 = date5;
        break;
    }
  }

  InitSeasons() {
    this.Season1OriginalStartDate = "";
    this.Season1OriginalEndDate = "";
    this.Season1TextStartDate = "";
    this.Season1TextEndDate = "";
    this.Season1StartDate = "";
    this.Season1EndDate = "";
    this.Season1Valid = false;
    this.Season1ExpectedPrice = "-1";
    this.Season1Dynamic = false;
    this.Season2OriginalStartDate = "";
    this.Season2OriginalEndDate = "";
    this.Season2TextStartDate = "";
    this.Season2TextEndDate = "";
    this.Season2StartDate = "";
    this.Season2EndDate = "";
    this.Season2Valid = false;
    this.Season2ExpectedPrice = "-1";
    this.Season2Dynamic = false;
    this.Season3OriginalStartDate = "";
    this.Season3OriginalEndDate = "";
    this.Season3TextStartDate = "";
    this.Season3TextEndDate = "";
    this.Season3StartDate = "";
    this.Season3EndDate = "";
    this.Season3Valid = false;
    this.Season3ExpectedPrice = "-1";
    this.Season3Dynamic = false;
    this.Season4OriginalStartDate = "";
    this.Season4OriginalEndDate = "";
    this.Season4TextStartDate = "";
    this.Season4TextEndDate = "";
    this.Season4StartDate = "";
    this.Season4EndDate = "";
    this.Season4Valid = false;
    this.Season4ExpectedPrice = "-1";
    this.Season4Dynamic = false;
    this.Season5OriginalStartDate = "";
    this.Season5OriginalEndDate = "";
    this.Season5TextStartDate = "";
    this.Season5TextEndDate = "";
    this.Season5StartDate = "";
    this.Season5EndDate = "";
    this.Season5Valid = false;
    this.Season5ExpectedPrice = "-1";
    this.Season5Dynamic = false;
    this.Season6OriginalStartDate = "";
    this.Season6OriginalEndDate = "";
    this.Season6TextStartDate = "";
    this.Season6TextEndDate = "";
    this.Season6StartDate = "";
    this.Season6EndDate = "";
    this.Season6Valid = false;
    this.Season6ExpectedPrice = "-1";
    this.Season6Dynamic = false;
    this.Season7OriginalStartDate = "";
    this.Season7OriginalEndDate = "";
    this.Season7TextStartDate = "";
    this.Season7TextEndDate = "";
    this.Season7StartDate = "";
    this.Season7EndDate = "";
    this.Season7Valid = false;
    this.Season7ExpectedPrice = "-1";
    this.Season7Dynamic = false;
    this.Season8OriginalStartDate = "";
    this.Season8OriginalEndDate = "";
    this.Season8TextStartDate = "";
    this.Season8TextEndDate = "";
    this.Season8StartDate = "";
    this.Season8EndDate = "";
    this.Season8Valid = false;
    this.Season8ExpectedPrice = "-1";
    this.Season8Dynamic = false;

    this.Season1Ceiling = null;
    this.Season2Ceiling = null;
    this.Season3Ceiling = null;
    this.Season4Ceiling = null;
    this.Season5Ceiling = null;
    this.Season6Ceiling = null;
    this.Season7Ceiling = null;
    this.Season8Ceiling = null;
  }
}

export function GetSeason(data: Property, season: number) {
  switch (season) {
    case 1: return {
      OriginalStartDate: data.Season1OriginalStartDate,
      OriginalEndDate: data.Season1OriginalEndDate,
      TextStartDate: data.Season1TextStartDate,
      TextEndDate: data.Season1TextEndDate,
      StartDate: data.Season1StartDate,
      EndDate: data.Season1EndDate,
      Valid: data.Season1Valid,
      DateToCheck1: data.Season1DateToCheck1,
      DateToCheck2: data.Season1DateToCheck2,
      DateToCheck3: data.Season1DateToCheck3,
      DateToCheck4: data.Season1DateToCheck4,
      DateToCheck5: data.Season1DateToCheck5,
      ExpectedPrice: data.Season1ExpectedPrice,
      Dynamic: data.Season1Dynamic,
      Ceiling: data.Season1Ceiling,
 };
    case 2: return {
      OriginalStartDate: data.Season2OriginalStartDate,
      OriginalEndDate: data.Season2OriginalEndDate,
      TextStartDate: data.Season2TextStartDate,
      TextEndDate: data.Season2TextEndDate,
      StartDate: data.Season2StartDate,
      EndDate: data.Season2EndDate,
      Valid: data.Season2Valid,
      DateToCheck1: data.Season2DateToCheck1,
      DateToCheck2: data.Season2DateToCheck2,
      DateToCheck3: data.Season2DateToCheck3,
      DateToCheck4: data.Season2DateToCheck4,
      DateToCheck5: data.Season2DateToCheck5,
      ExpectedPrice: data.Season2ExpectedPrice,
      Dynamic: data.Season2Dynamic,
      Ceiling: data.Season2Ceiling,
    };
    case 3: return {
      OriginalStartDate: data.Season3OriginalStartDate,
      OriginalEndDate: data.Season3OriginalEndDate,
      TextStartDate: data.Season3TextStartDate,
      TextEndDate: data.Season3TextEndDate,
      StartDate: data.Season3StartDate,
      EndDate: data.Season3EndDate,
      Valid: data.Season3Valid,
      DateToCheck1: data.Season3DateToCheck1,
      DateToCheck2: data.Season3DateToCheck2,
      DateToCheck3: data.Season3DateToCheck3,
      DateToCheck4: data.Season3DateToCheck4,
      DateToCheck5: data.Season3DateToCheck5,
      ExpectedPrice: data.Season3ExpectedPrice,
      Dynamic: data.Season3Dynamic,
      Ceiling: data.Season3Ceiling,
    };
    case 4: return {
      OriginalStartDate: data.Season4OriginalStartDate,
      OriginalEndDate: data.Season4OriginalEndDate,
      TextStartDate: data.Season4TextStartDate,
      TextEndDate: data.Season4TextEndDate,
      StartDate: data.Season4StartDate,
      EndDate: data.Season4EndDate,
      Valid: data.Season4Valid,
      DateToCheck1: data.Season4DateToCheck1,
      DateToCheck2: data.Season4DateToCheck2,
      DateToCheck3: data.Season4DateToCheck3,
      DateToCheck4: data.Season4DateToCheck4,
      DateToCheck5: data.Season4DateToCheck5,
      ExpectedPrice: data.Season4ExpectedPrice,
      Dynamic: data.Season4Dynamic,
      Ceiling: data.Season4Ceiling,
 };
    case 5: return {
      OriginalStartDate: data.Season5OriginalStartDate,
      OriginalEndDate: data.Season5OriginalEndDate,
      TextStartDate: data.Season5TextStartDate,
      TextEndDate: data.Season5TextEndDate,
      StartDate: data.Season5StartDate,
      EndDate: data.Season5EndDate,
      Valid: data.Season5Valid,
      DateToCheck1: data.Season5DateToCheck1,
      DateToCheck2: data.Season5DateToCheck2,
      DateToCheck3: data.Season5DateToCheck3,
      DateToCheck4: data.Season5DateToCheck4,
      DateToCheck5: data.Season5DateToCheck5,
      ExpectedPrice: data.Season5ExpectedPrice,
      Dynamic: data.Season5Dynamic,
      Ceiling: data.Season5Ceiling,
    };
    case 6: return {
      OriginalStartDate: data.Season6OriginalStartDate,
      OriginalEndDate: data.Season6OriginalEndDate,
      TextStartDate: data.Season6TextStartDate,
      TextEndDate: data.Season6TextEndDate,
      StartDate: data.Season6StartDate,
      EndDate: data.Season6EndDate,
      Valid: data.Season6Valid,
      DateToCheck1: data.Season6DateToCheck1,
      DateToCheck2: data.Season6DateToCheck2,
      DateToCheck3: data.Season6DateToCheck3,
      DateToCheck4: data.Season6DateToCheck4,
      DateToCheck5: data.Season6DateToCheck5,
      ExpectedPrice: data.Season6ExpectedPrice,
      Dynamic: data.Season6Dynamic,
      Ceiling: data.Season6Ceiling,
    };
    case 7: return {
      OriginalStartDate: data.Season7OriginalStartDate,
      OriginalEndDate: data.Season7OriginalEndDate,
      TextStartDate: data.Season7TextStartDate,
      TextEndDate: data.Season7TextEndDate,
      StartDate: data.Season7StartDate,
      EndDate: data.Season7EndDate,
      Valid: data.Season7Valid,
      DateToCheck1: data.Season7DateToCheck1,
      DateToCheck2: data.Season7DateToCheck2,
      DateToCheck3: data.Season7DateToCheck3,
      DateToCheck4: data.Season7DateToCheck4,
      DateToCheck5: data.Season7DateToCheck5,
      ExpectedPrice: data.Season7ExpectedPrice,
      Dynamic: data.Season7Dynamic,
      Ceiling: data.Season7Ceiling,
    };
    case 8: return {
      OriginalStartDate: data.Season8OriginalStartDate,
      OriginalEndDate: data.Season8OriginalEndDate,
      TextStartDate: data.Season8TextStartDate,
      TextEndDate: data.Season8TextEndDate,
      StartDate: data.Season8StartDate,
      EndDate: data.Season8EndDate,
      Valid: data.Season8Valid,
      DateToCheck1: data.Season8DateToCheck1,
      DateToCheck2: data.Season8DateToCheck2,
      DateToCheck3: data.Season8DateToCheck3,
      DateToCheck4: data.Season8DateToCheck4,
      DateToCheck5: data.Season8DateToCheck5,
      ExpectedPrice: data.Season8ExpectedPrice,
      Dynamic: data.Season8Dynamic,
      Ceiling: data.Season8Ceiling,
    }
  }

}

